/**
 * @author shreyas.hande on 6/12/18
 *
 */

import formurlencoded from 'form-urlencoded';

import FetchHelper from '../FetchHelper';
import { API_URL } from '../../constants';
import { updateConfig, configUpdated } from '../../actions/ConfigActions';
import { updateUser } from '../../actions/UserActions';
import { JobStore } from '../../store';
import store from '../../store';
import JobsPostAdRequest from '../../utils/JobsPostAd/jobsPostAdRequest';
import { Validator } from '../JobsPostAd/genericValidator';
import root from 'window-or-global';


export default class Config {
  static get = (key, store) => store ? store.config[key] : null;

  static hasKey = (key, store) => store ? store.config.hasOwnProperty(key) : null;

  static updateConfig(updatedConfig, jobStore) {
    store.dispatch(updateConfig(updatedConfig, jobStore));
    store.dispatch(configUpdated({}, jobStore));
  }

  static updateConfigForCategory(params) {
    let { cityId = null, subCatId = null, cityname = null, roleName = null, adId = null } = params;
    let apiParams = {};

    if (!Validator.isEmpty(adId))
        apiParams.adId = adId;
    else
        apiParams.adId = '';

    if (!Validator.isEmpty(cityId))
        apiParams.cityId = cityId;
    else
        apiParams.cityId = '';

    if (!Validator.isEmpty(cityname))
        apiParams.cityname = cityname;
    else
        apiParams.cityname = '';

    if (!Validator.isEmpty(subCatId))
        apiParams.subCatId = subCatId;

    if (!Validator.isEmpty(roleName))
        apiParams.roleName = roleName;

    let url = root.location.protocol + '//' + API_URL + '/getPremiumPriceJobs';

    let options = {
      url,
      data: formurlencoded(apiParams)
    };

    let fetchHelper = new FetchHelper();
    let responsePromise = fetchHelper.request('post', options);
    responsePromise.then(apiResponse => {
      let response = apiResponse.data;
      if ('undefined' !== typeof response) {
        let updatedConfig = {
          papPrices: response
        };

        const jobStore = JobStore.getState();
        Config.updateConfig(updatedConfig, jobStore);

        let updatedUserDetails = {
          hasCredits: response.userCredit,
          credits: response.userCreditNo,
          whatsappConnectCredits: response.whatsappConnectCredits
        };

        store.dispatch(updateUser(updatedUserDetails));
        JobsPostAdRequest.updateRedux();
      }
    });
  }

  static activeWhatsappPackForAd(adId) {
    let apiParams = {};

    if (!Validator.isEmpty(adId))
        apiParams.adId = adId;

    let url = root.location.protocol + '//' + API_URL + '/activateWhatsappConnect';
    let options = {
      url,
      data: formurlencoded(apiParams)
    };
    let fetchHelper = new FetchHelper();
    let responsePromise = fetchHelper.request('post', options);
    
    return responsePromise;
  }

  static isUnlimitedFreeAdsEnabled = cityname => {
    let isEnabled = false;
    const { config } = JobStore.getState();

    if ('undefined' !== typeof config) {
      isEnabled = ((-1 !== config.jobsUnlimitedFreeAdsEnabledCities.indexOf(cityname)) || (-1 !== config.jobsUnlimitedFreeAdsEnabledCities.indexOf('all')));
    }

    return isEnabled;
  };
}



// WEBPACK FOOTER //
// ../q-jobs/src/utils/Config/index.js